































































































































































































































































































































































































































































































































































































































import {treeselect} from '@/api/system/dept';
import {getDicts} from '@/api/system/dict/data';
import {changeUserStatus, getUser, importTemplate, listUser} from '@/api/system/user';
import {api} from '@/plugins/api';
import {SysUser} from '@/types/api-beans';
import {getToken} from '@/utils/auth';
import {addDateRange, download} from '@/utils/ruoyi';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {ElForm} from 'element-ui/types/form';
import {ElTree} from 'element-ui/types/tree';
import {ElUpload} from 'element-ui/types/upload';
import Vue from 'vue';
import {msgSuccess} from '../../../plugins/element';
export default Vue.extend({
  name: 'User',
  components: {Treeselect},
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 用户表格数据
      userList: null,
      // 弹出层标题
      title: '',
      // 部门树选项
      deptOptions: undefined,
      // 是否显示弹出层
      open: false,
      // 部门名称
      deptName: undefined,
      // 默认密码
      initPassword: '',
      // 日期范围
      dateRange: [],
      // 状态数据字典
      statusOptions: [],
      // 性别状态字典
      sexOptions: [],
      // 岗位选项
      postOptions: [],
      // 角色选项
      roleOptions: [],
      // 表单参数
      form: {
        userId: undefined,
        password: '',
        postIds: undefined,
        roleIds: undefined
      } as SysUser,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: {Authorization: 'Bearer ' + getToken()},
        // 上传的地址
        url: process.env.VUE_APP_BASE_API + '/system/user/importData'
      },
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userName: undefined,
        phonenumber: undefined,
        status: undefined,
        deptId: undefined,
        nickName: undefined,
        beginTime: null,
        endTime: null
      },
      // 列信息
      columns: [
        {key: 0, label: '用户编号', visible: true},
        {key: 1, label: '用户名称', visible: true},
        {key: 2, label: '用户昵称', visible: true},
        {key: 3, label: '部门', visible: true},
        {key: 4, label: '手机号码', visible: true},
        {key: 5, label: '状态', visible: true},
        {key: 6, label: '创建时间', visible: true}
      ],
      // 表单校验
      rules: {
        userName: [
          {required: true, message: '用户名称不能为空', trigger: 'blur'}
        ],
        nickName: [
          {required: true, message: '用户昵称不能为空', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '用户密码不能为空', trigger: 'blur'}
        ],
        email: [
          {
            type: 'email',
            message: '\'请输入正确的邮箱地址',
            trigger: ['blur', 'change']
          }
        ],
        // phonenumber: [
        //   {
        //     pattern: /^1[3|456789][0-9]\d{8}$/,
        //     message: '请输入正确的手机号码',
        //     trigger: 'blur'
        //   }
        // ]
      }
    };
  },
  watch: {
    // 根据名称筛选部门树
    deptName(val) {
      (this.$refs.tree as ElTree<any, any>).filter(val);
    }
  },
  created() {
    this.getList();
    this.getTreeselect();
    getDicts('sys_normal_disable').then(response => {
      this.statusOptions = response.data;
    });
    getDicts('sys_user_sex').then(response => {
      this.sexOptions = response.data;
    });
    api.system.config.configKey.getConfigKey.requestData('sys.user.initPassword').then(pass => {
      this.initPassword = pass;
    });
  },
  methods: {
    indexMethod(index) {
      return index + (this.queryParams.pageNum -1)* this.queryParams.pageSize + 1;
    },
    /** 查询用户列表 */
    getList() {
      this.loading = true;
      console.info("dateRage====", this.dateRange);
      if(this.dateRange != null && this.dateRange.length > 0) {
        this.queryParams.beginTime = (this.dateRange[0] + ' 00:00:00');
      }else {
        this.queryParams.beginTime = null;
      }
      if(this.dateRange != null && this.dateRange.length > 1) {
        this.queryParams.endTime = (this.dateRange[1] + ' 23:59:59');
      }else {
        this.queryParams.endTime = null;
      }

      listUser(addDateRange(this.queryParams, this.dateRange)).then(response => {
          this.userList = response.rows;
          this.total = response.total;
          this.loading = false;
        }
      );
    },
    /** 查询部门下拉树结构 */
    getTreeselect() {
      treeselect().then(response => {
        this.deptOptions = response.data;
      });
    },
    // 筛选节点
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 节点单击事件
    handleNodeClick(data) {
      this.queryParams.deptId = data.id;
      this.getList();
    },
    // 用户状态修改
    handleStatusChange(row) {
      let text = row.status === '0' ? '启用' : '停用';
      this.$confirm('确认要"' + text + '""' + row.userName + '"用户吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function() {
        return changeUserStatus(row.userId, row.status);
      }).then(() => {
        msgSuccess(text + '成功');
      }).catch(function() {
        row.status = row.status === '0' ? '1' : '0';
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        userId: undefined,
        deptId: undefined,
        userName: undefined,
        nickName: undefined,
        password: undefined,
        phonenumber: undefined,
        email: undefined,
        sex: undefined,
        status: '0',
        insuranceCode: undefined,
        remark: undefined,
        postIds: [],
        roleIds: [],
        extension: undefined,
        latitude: undefined, // 纬度
        longitude: undefined, // 经度
      };
      this.resetForm('form');
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      // this.resetForm('queryForm');
     this.resetParams();
      this.handleQuery();
    },

    async resetParams() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        userName: undefined,
        phonenumber: undefined,
        status: undefined,
        deptId: undefined,
        nickName: undefined
      }
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.userId);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.getTreeselect();
      getUser().then(response => {
        this.postOptions = response.posts;
        this.roleOptions = response.roles;
        this.open = true;
        this.title = '添加用户';
        this.form.password = this.initPassword;
      });
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      this.getTreeselect();
      const userId = row.userId || this.ids;
      getUser(userId).then(response => {
        this.form = response.data;
        this.postOptions = response.posts;
        this.roleOptions = response.roles;
        this.open = true;
        this.title = '修改用户';
        this.form.password = '';
      });
    },
    /** 重置密码按钮操作 */
    handleResetPwd(row) {
      this.$prompt('请输入"' + row.userName + '"的新密码', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({value}: any) => {
        this.$api.system.user.resetPwd.r({
          userId: row.userId,
          password: value
        }).then(() => {
          msgSuccess('修改成功，新密码是：' + value);
        });
      }).catch(() => {
      });
    },
    /** 提交按钮 */
    submitForm: function() {
      (this.$refs['form'] as ElForm).validate(valid => {
        if (valid) {
          if (this.form.userId) {
            this.$api.system.user.update.r(this.form).then(() => {
              msgSuccess('修改成功');
              this.open = false;
              this.getList();
            });
          } else {
            this.$api.system.user.add.r(this.form).then(() => {
              msgSuccess('新增成功');
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const userIds = row.userId || this.ids;
      this.$confirm('是否确认删除用户编号为"' + userIds + '"的数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function() {
        return api.system.user.remove.requestData(userIds);
      }).then(() => {
        this.getList();
        msgSuccess('删除成功');
      });
    },
    /** 导出按钮操作 */
    handleExport() {
      const queryParams = this.queryParams;
      this.$confirm('是否确认导出所有用户数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function() {
        return api.system.user.export.r(queryParams);
      }).then(value => {
        download(value);
      });
    },
    /** 导入按钮操作 */
    handleImport() {
      this.upload.title = '用户导入';
      this.upload.open = true;
    },
    /** 下载模板操作 */
    importTemplate() {
      importTemplate().then(response => {
        download(response.data);
      });
    },
    // 文件上传中处理
    handleFileUploadProgress() {
      this.upload.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess(response) {
      this.upload.open = false;
      this.upload.isUploading = false;
      (this.$refs.upload as ElUpload).clearFiles();
      this.$alert(response.msg, '导入结果', {dangerouslyUseHTMLString: true});
      this.getList();
    },
    // 提交上传文件
    submitFileForm() {
      (this.$refs.upload as ElUpload).submit();
    }
  }
});
